import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
} from "@angular/router";

import { MESSAGE_HTML_ERROR_ACCESS } from "@app/core/data/constants";
import { IPermissions } from "@app/core/interfaces/permissions";
import { AuthService } from "@app/core/services";
import { IndexedUseCaseState } from "@app/flow/core/models/flow.model";
import { StateUseCaseGroupService } from "@app/flow/core/services/state-use-case-group.service";
import { ApiUseCaseGroupService } from "@app/flow/core/services/use-case-group.service";
import { HotToastService } from "@ngneat/hot-toast";
import { Observable, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { PATH_REDIRECT_TO } from "src/app/routes";
import { StateUseCaseService } from "../services/state-use-case.service";

@Injectable({
    providedIn: "root",
})
export class MustBeActivatedDashboard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService,
        private hotToastService: HotToastService,
        private apiUseCaseGroupService: ApiUseCaseGroupService,
        private stateUseCaseGroupService: StateUseCaseGroupService,
        private _stateUseCaseService: StateUseCaseService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        const slugGroup = route.params.slug ?? "";

        const { idFlow } = route.children[0].params;

        return this.apiUseCaseGroupService.findBySlug(slugGroup).pipe(
            switchMap((group) => {
                // 1. filtrar los permisos por caso de uso

                const useCaseRoles = group.use_cases
                    .map((useCase) => useCase.roles)
                    .reduce((acc, roles) => acc.concat(roles), [])
                    .filter(
                        (role, index, self) => self.indexOf(role) === index
                    );
                const allUserPermissions = this.authService.getPermissions();

                // const userPermissionsByUseCase =
                //     this.getUserPermissionsByUseCase(
                //         allUserPermissions,
                //         useCaseRoles
                //     );

                // console.log(userPermissionsByUseCase)

                // 2. verificar si tiene permisos al caso de uso
                // Si el listado no contiene permisos, no accede a la ruta
                // if (!userPermissionsByUseCase.length) {
                //     this.router.navigate([PATH_REDIRECT_TO]).then(() => {
                //         this.hotToastService.error(
                //             MESSAGE_HTML_ERROR_ACCESS(),
                //             {
                //                 duration: 5000,
                //                 dismissible: true,
                //                 id: "error-permission",
                //             }
                //         );
                //     });

                //     return of(false);
                // }

                // if (
                //     idFlow &&
                //     !group.use_cases.some(
                //         (useCase) => useCase.id.toString() === idFlow
                //     )
                // ) {
                //     this.router.navigate([PATH_REDIRECT_TO]).then(() => {
                //         this.hotToastService.error(
                //             MESSAGE_HTML_ERROR_ACCESS(),
                //             {
                //                 duration: 5000,
                //                 dismissible: true,
                //                 id: "error-permission",
                //             }
                //         );
                //     });

                //     return of(false);
                // }

                // 3. Si tiene permisos guardar los datos y acceder al caso de uso
                // guarda los datos del caso en un servicio estado
                const indexedUseCases: IndexedUseCaseState[] =
                    group.use_cases.map((useCase) => ({
                        id: useCase.id,
                        name: useCase.name,
                        role: useCase.role,
                        roles: this.getUserPermissionsByUseCase(
                            allUserPermissions,
                            useCase.roles
                        ),
                        is_massive: Boolean(useCase.is_massive),
                        delete_permissions: Array.isArray(useCase.delete_permissions) ? useCase.delete_permissions : [],
                        massive_button_label: useCase.massive_button_label,
                        use_case_image_url: useCase.use_case_image_url
                    }));

                this.stateUseCaseGroupService.save({
                    id: group.id,
                    slug: group.slug,
                    name: group.name,
                    roles: [],
                    use_cases: indexedUseCases,
                });

                return of(true);
            }),
            catchError(() => {
                this.router.navigate([PATH_REDIRECT_TO]);
                this.hotToastService.error(MESSAGE_HTML_ERROR_ACCESS(), {
                    duration: 5000,
                    dismissible: true,
                });
                return of(false);
            })
        );
    }

    private getUserPermissionsByUseCase(
        all: IPermissions[],
        useCaseRoles: string[]
    ): IPermissions[] {
        return all.filter((userPermission) => {
            return useCaseRoles.some(
                (useCaseRole) =>
                    useCaseRole.toUpperCase() ===
                    userPermission.name.toUpperCase()
            );
        });
    }
}
